import React from 'react';


const Processing = () => (
  <div className="row">
    <div className="col-md-6 pull-left">
      <label>
        Processing...
      </label>
      <br /><br />
    </div>
  </div>
);

export default Processing;


// WEBPACK FOOTER //
// ./app/javascript/components/card_details/components/UI/Processing.js